// Selectors
import { getSelectedElementIds } from './selection/selectedElementsSelector';
import { getPresentationModeIsFocusModeAllowed } from '../workspace/presentation/presentationSelector';

// Actions
import { updateElement } from './actions/elementActions';
import { showGuestAppRegistrationForm } from '../reducers/guestNavigationActions';
import { focusElementAppearing } from '../workspace/presentation/presentationActions';
import { finishEditingElement, startEditingElement } from './selection/selectionActions';
import { handleSelectionModeSelectElement } from './actions/elementSelectionActions';

export default (dispatch) => ({
    dispatchUpdateElement: ({ id, changes, sync, analyticsEvent, transactionId }) =>
        dispatch(updateElement({ id, changes, sync, analyticsEvent, transactionId })),
    dispatchGetSelectedElementIds: () => dispatch((_, getState) => getSelectedElementIds(getState())),
    dispatchHandleSelectionModeSelectElement: (id, selectionMode, transactionId) =>
        dispatch(handleSelectionModeSelectElement(id, selectionMode, transactionId)),
    dispatchStartEditingElement: ({ id, editorId, editorKey }) =>
        dispatch(startEditingElement({ id, editorId, editorKey })),
    dispatchStopEditing: (id) => dispatch(finishEditingElement(id)),
    dispatchShowGuestAppRegistrationForm: () => dispatch(showGuestAppRegistrationForm()),
    dispatchFocusElementStart: (elementId, initialZoomScale, elementProps) => {
        dispatch(focusElementAppearing(elementId, initialZoomScale, elementProps));
        dispatch(finishEditingElement(elementId));
    },
    dispatchGetPresentationModeIsFocusModeAllowed: () =>
        dispatch((_, getState) => getPresentationModeIsFocusModeAllowed(getState())),
});
